import React, { useEffect } from 'react';

import SocialLinks from './SocialLinks';

const PageTitle = () => {
    const backgrounImage = require( '../../assets/img/pagetitle/pagetitle.jpg');

    useEffect(() => {
        if ( document.querySelector('.page-title-img') ) {
            document.querySelector('.site-main').classList.add('overflow-hidden');
        }

        return () => {
            if ( document.querySelector('.site-main').classList.contains('overflow-hidden') ) {
                document.querySelector('.site-main').classList.remove('overflow-hidden');
            }
        }
    });

    return (
        <section id="page-title" className="block bg-secondary">
            <div className="wrapper">
                <div className="row gutter-width-md">
                    <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12">
                        <div className="page-title-content">
                            <div className="title" data-aos="fade-down">
                                <h1 className="large">Ahoj. Ja som Ivana <br/>Mudroňová</h1>
                            </div>

                            <div className="description spacer p-top-lg" data-aos="fade-up">
                                <p>Kondičná trénerka, inštruktorka outdoorových aktivít a špecialistka na región Liptov.</p>
                            </div>

                            <div className="my-information spacer p-top-lg" data-aos="fade-up">
                                <div className="my-information-items">
                                    <div className="my-information-item" data-aos="zoom-in" data-aos-delay="200">
                                        <h6 className="my-information-item-title">Celé meno</h6>

                                        <p className="my-information-item-description">Ivana Mudroňová</p>
                                    </div>

                                    <div className="my-information-item" data-aos="zoom-in" data-aos-delay="400">
                                        <h6 className="my-information-item-title">Vek</h6>

                                        <p className="my-information-item-description">{Math.floor((new Date() - Date.parse("19 Jul 1970")) / 3.15576e+10)}</p>
                                    </div>

                                    <div className="my-information-item" data-aos="zoom-in" data-aos-delay="600">
                                        <h6 className="my-information-item-title">Addresa</h6>

                                        <p className="my-information-item-description">Liptovský Mikuláš, Slovensko</p>
                                    </div>

                                    <div className="my-information-item" data-aos="zoom-in" data-aos-delay="800">
                                        <h6 className="my-information-item-title">Email</h6>

                                        <p className="my-information-item-description"><a href="mailto:info@ivanamudron.com">info@ivanamudron.com</a></p>
                                    </div>

                                    <div className="my-information-item" data-aos="zoom-in" data-aos-delay="1000">
                                        <h6 className="my-information-item-title">Tel. číslo</h6>

                                        <p className="my-information-item-description"><a href="tel:+43253312523">+421 905 186 348</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="spacer p-top-lg" data-aos="fade-up">
                                <SocialLinks />
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12">
                        <div className="page-title-img" style={{ backgroundImage: `url(${backgrounImage})` }} data-aos="zoom-in-left"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageTitle;
